module.exports = __webpack_public_path__ + "static/media/36x36-7.31d9d325.png";